export function createForYouBootstrapState() {
  let instanceCount = 0;
  let unsubscribe: (() => void) | null = null;
  let hasLoadedInitial = false;
  let isEnabled = true;
  return {
    setEnabled(enabled: boolean) {
      isEnabled = enabled;
    },
    enabled: () => isEnabled,
    enter() {
      instanceCount += 1;
      return instanceCount === 1;
    },
    claimInitial() {
      if (hasLoadedInitial) return false;
      hasLoadedInitial = true;
      return true;
    },
    attach(stop: () => void) {
      unsubscribe = stop;
    },
    release() {
      instanceCount = Math.max(0, instanceCount - 1);
      if (instanceCount === 0) {
        unsubscribe?.();
        unsubscribe = null;
      }
    },
  };
}
